import React from "react";
import {
  createUpdateWorkType,
  getWorkTypes,
} from "../../helpers/backend_helper";
import MasterList from "./MasterList";

const WorkType = ({ createRequest = 0, tourRequest = 0 }) => (
  <MasterList
    createRequest={createRequest}
    tourRequest={tourRequest}
    label="Work Type"
    pluralLabel="Work Types"
    listMasters={() => getWorkTypes(true)}
    createMaster={createUpdateWorkType}
    fileName="work-types"
  />
);

export default WorkType;
